import { IKImage } from 'imagekitio-react';
import { IKImageProps } from 'imagekitio-react/dist/types/components/IKImage/combinedProps';
import React from 'react';

import { useBool } from '@barboxx/react-utils';

export type ImageProps = Omit<IKImageProps, 'src' | 'onError'> & {
    fallback?: React.ReactNode;
};

export function Image({ path = '', fallback, ...props }: ImageProps) {
    const [hasError, errorActions] = useBool();

    React.useEffect(() => {
        if (path && hasError) {
            errorActions.off();
        }
    }, [errorActions, hasError, path]);

    if (hasError && fallback) {
        return fallback;
    }

    return (
        <IKImage
            path={path}
            onError={e => {
                errorActions.on();
            }}
            key={path}
            {...props}
        />
    );
}
